import React, { useState } from 'react';
import '../styles/Footer.css';
import { useTranslation } from 'react-i18next';  
import '../../i18n';

const CookieConsentModal = ({ isOpen, onClose }) => {
  const [preferences, setPreferences] = useState({
    necessary: true, // Toujours actif
    analytics: false,
    marketing: false,
  });
  const { t } = useTranslation();


  const handlePreferenceChange = (type, value) => {
    setPreferences((prev) => ({
      ...prev,
      [type]: value,
    }));
  };

  const handleAcceptAll = () => {
    setPreferences({
      necessary: true,
      analytics: true,
      marketing: true,
    });
    onClose();
  };

  const handleRejectAll = () => {
    setPreferences({
      necessary: true,
      analytics: false,
      marketing: false,
    });
    onClose();
  };

  const handleSavePreferences = () => {
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className="cookie-consent-overlay">
      <div className="cookie-consent-modal">
        <h2>{t("coqtitle")}</h2>
        <p>
          {t("coqtp")}
        </p>

        <div className="cookie-categories">

          <div>
            <p>
              {t("cooqp")}
            </p>
            <label>
              <input
                type="checkbox"
                checked={preferences.analytics}
                onChange={(e) =>
                  handlePreferenceChange("analytics", e.target.checked)
                }
              />
              {t("active")}
            </label>
          </div>
          <div>
            <h3>{t("coqmark")}</h3>
            <p>
              {t("messucaop")}
            </p>
            <label>
              <input
                type="checkbox"
                checked={preferences.marketing}
                onChange={(e) =>
                  handlePreferenceChange("marketing", e.target.checked)
                }
              />
               {t("active")}
            </label>
          </div>
        </div>
        <div className="cookie-actions">
          <button className="reject-btn" onClick={handleRejectAll}>
          {t("rej")}
          </button>
          <button className="save-btn" onClick={handleSavePreferences}>
          {t("pref")}
          </button>
          <button className="accept-btn" onClick={handleAcceptAll}>
          {t("accep")}
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieConsentModal;
